// Score — a normalized measurement on the produced VALUE, in [0, 1].
//
// The report-card axis (OD2, `docs/model/constraints.md` §Graded
// degree-of-fit): the model shows a SCORE (a measurement) while
// enforcement stays two-level. Grade the produced value, NOT the
// severity. A Score is precisely "a measurement the constraint produces"
// (the project principle *Quality is a measurement, not a judgement*),
// not a force the policy assigns — so it lives on the observation
// (`./observation.ts`) and the aggregate evaluation (`./evaluate.ts`),
// never on `Severity`.
//
// 1.0 = the value fully meets the constraint; 0.0 = maximally off.
//
// Pure module. The `s as Score` in `mk` is the sanctioned brand site.
export { from, mk, to };
import { Result } from "@bilda/utils";
// Internal brand + clamp. Callers producing a score from an already-
// bounded measurement (a coverage ratio, a resolved fraction) go through
// here; the clamp is belt-and-braces so a formula that drifts slightly
// out of range can never mint an illegal Score.
const mk = (n) => {
    const clamped = n < 0 ? 0 : n > 1 ? 1 : n;
    return clamped;
};
// Smart constructor for untrusted numbers (e.g. a judged verdict's
// fitScore arriving from the shell). Rejects NaN and out-of-range rather
// than silently clamping — a boundary parse, not a coercion.
const to = (n) => Number.isFinite(n) && n >= 0 && n <= 1
    ? Result.ok(n)
    : Result.err(`Score must be a finite number in [0, 1], got ${n}`);
const from = (s) => s;
//# sourceMappingURL=score.js.map